import script from "./Examine.vue?vue&type=script&setup=true&lang=js"
export * from "./Examine.vue?vue&type=script&setup=true&lang=js"

import "./Examine.vue?vue&type=style&index=0&id=0c0d3df6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lp\\Desktop\\ConfChair\\用户端\\vue-conference\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c0d3df6"]])

export default __exports__